module.exports = __webpack_public_path__ + "img/03_TwispWorks.bee29b9e.jpg";